// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { Inbox_CommentFragmentDoc } from './CommentableInbox.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CommentStreamCommentsQueryVariables = Types.Exact<{
  streamId: Types.Scalars['ID']['input'];
}>;


export type CommentStreamCommentsQuery = { __typename?: 'Query', commentStream?: { __typename?: 'CommentStream', id: string, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], author: { __typename?: 'User', id: string, avatarUrl: string, name: string, type: Types.UserType, internalUser?: { __typename?: 'InternalUser', id: string } | null | undefined }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string, internalUser: { __typename?: 'InternalUser', id: string } }> }> } | null | undefined };


export const CommentStreamCommentsDocument = gql`
    query CommentStreamComments($streamId: ID!) {
  commentStream(id: $streamId) {
    id
    comments {
      ...Inbox_Comment
    }
  }
}
    ${Inbox_CommentFragmentDoc}`;

/**
 * __useCommentStreamCommentsQuery__
 *
 * To run a query within a React component, call `useCommentStreamCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentStreamCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentStreamCommentsQuery({
 *   variables: {
 *      streamId: // value for 'streamId'
 *   },
 * });
 */
export function useCommentStreamCommentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CommentStreamCommentsQuery, CommentStreamCommentsQueryVariables> & ({ variables: CommentStreamCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CommentStreamCommentsQuery, CommentStreamCommentsQueryVariables>(CommentStreamCommentsDocument, options);
      }
export function useCommentStreamCommentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CommentStreamCommentsQuery, CommentStreamCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CommentStreamCommentsQuery, CommentStreamCommentsQueryVariables>(CommentStreamCommentsDocument, options);
        }
export function useCommentStreamCommentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommentStreamCommentsQuery, CommentStreamCommentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CommentStreamCommentsQuery, CommentStreamCommentsQueryVariables>(CommentStreamCommentsDocument, options);
        }
export type CommentStreamCommentsQueryHookResult = ReturnType<typeof useCommentStreamCommentsQuery>;
export type CommentStreamCommentsLazyQueryHookResult = ReturnType<typeof useCommentStreamCommentsLazyQuery>;
export type CommentStreamCommentsSuspenseQueryHookResult = ReturnType<typeof useCommentStreamCommentsSuspenseQuery>;
export type CommentStreamCommentsQueryResult = Apollo.QueryResult<CommentStreamCommentsQuery, CommentStreamCommentsQueryVariables>;